import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=1d4a3f98&scoped=true&"
import script from "./FloatingChat.vue?vue&type=script&lang=js&"
export * from "./FloatingChat.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=1d4a3f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a3f98",
  null
  
)

export default component.exports